module.exports = __webpack_public_path__ + "img/fi-rr-cloud-check.b5d5adc5.svg";